import type { SVGProps } from 'react';

const CycleFieldsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='none'
    {...props}>
    <path
      fill='currentColor'
      d='M9 10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4Z'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M5 3h2v2h10V3h2v2h2v2h-2v10h2v2h-2v2h-2v-2H7v2H5v-2H3v-2h2V7H3V5h2V3Zm2 14V7h10v10H7Z'
      clipRule='evenodd'
    />
  </svg>
);

export default CycleFieldsIcon;
